import { loginRes } from '../Login.res';

// https://jira.lais.net/browse/WEB-39857
export const res = {
  tryagain: {
    ...loginRes.tryagain,
  },
  close: {
    is: 'Loka',
    en: 'Close',
    pl: 'Zamknij',
  },
  title: {
    is: 'Innskráning mistókst',
    en: 'Login unsuccessful',
    pl: 'Logowanie nie powiodło się',
  },
  title_consent: {
    is: 'Auðkenning mistókst',
    en: 'Authentication unsuccessful',
    pl: 'Identyfikacja nie powiodła się',
  },
  title_forbidden: {
    is: 'Sterkari auðkenningar er þörf',
    en: 'Stronger authentication required',
    pl: 'Potrzebna jest lepsza metoda identyfikacji',
  },
  description_fido: {
    is: 'Innskráning með lífkenni mistókst',
    en: 'Biometric login unsuccessful',
    pl: 'Logowanie biometryczne nie powiodło się',
  },
  description_password: {
    is: 'Notandanafn eða lykilorð var rangt',
    en: 'Wrong user name or password ',
    pl: 'Imię użytkownika lub hasło niepoprawne',
  },
  description_pkiSim: {
    is: 'Innskráning með rafrænum skilríkjum í síma mistókst',
    en: 'Login with electronic ID in mobile unsuccessful',
    pl: 'Logowanie identyfikacją elektroniczną w telefonie nie powiodło się',
  },
  description_audkenniApp: {
    is: 'Enginn notandi fannst hjá Auðkenni með þessa kennitölu',
    en: 'No user with this Id. No. found at Auðkenni',
    pl: 'W Auðkenni nie znaleziono użytkownika z niniejszym numerem ewidencyjnym',
  },
  description_app: {
    is: 'Innskráning með appi mistókst',
    en: 'App login unsuccessful',
    // TODO: Translate
  },
  auth_link_text: {
    is: 'Nánar um auðkenningarleiðir',
    en: 'More about authentication methods',
    pl: 'Więcej o sposobach identyfikacji',
  },
} as const;
